//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BlendRadius",0,"Expression",0],[1,"Bodies",0,"SelectBodyList",0],[0,"BodyCollector",0,"ScCollector",0],[1,"ChamferDistance",0,"Expression",0],[0,"DesignSpace",1,"DesignSimulation.DesignSpace",0],[0,"FaceCollector",0,"ScCollector",0],[0,"GroupingOption",1,0],[0,"Method",1,0],[0,"Name",1,0],[1,"Offset",0,"Expression",0],[0,"OffsetEdgesType",1,0],[1,"ThickenOffset",0,"Expression",0],[0,"Type",1,0],[1,"WallThickness",0,"Expression",0]],[],[]];
SPLM.DesignSimulation.ConstructionBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ConstructionBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.ConstructionBodyBuilder.ConstructionType = Object.freeze({
    "ByBody" : "ByBody", "ByFace" : "ByFace"});

SPLM.DesignSimulation.ConstructionBodyBuilder.GroupingType = Object.freeze({
    "Separate" : "Separate", "Collection" : "Collection"});

SPLM.DesignSimulation.ConstructionBodyBuilder.MethodOption = Object.freeze({
    "KeepIn" : "KeepIn", "KeepOut" : "KeepOut", "Shell" : "Shell"});

SPLM.DesignSimulation.ConstructionBodyBuilder.OffsetType = Object.freeze({
    "None" : "None", "Automatic" : "Automatic", "WithRadius" : "WithRadius", "WithChamfer" : "WithChamfer"});

export default SPLM;